import * as moment from 'moment';
import { auth, database } from '../firebase';

export const retrieveContactLists = async info => {
	try{
		const fullContactList = []
		const allContactLists = await database.collection("companies").doc(info.company).collection("contactLists").orderBy("timestamp").get()
		if(allContactLists.size > 0){
			allContactLists.forEach((contactList) => {
				const single = fetchContactList(contactList.id, contactList.data())
				fullContactList.push(single)
			})
		}
		return Promise.all(fullContactList).then((result) => {
			return {payload: result, error: null}
		})
	} catch(e) {
		throw new Error(e)
	}
}

export const fetchContactList = (contactListId, contactList) => {
	return new Promise((resolve, reject) => {
		database.collection("users").doc(contactList.addedBy).get().then((user) => {
			if(user.exists){
				resolve({
                    name: contactList.name,
                    size: contactList.size,
                    id: contactListId,
                    timestamp: contactList.timestamp,
					description: contactList.description,
                    addedBy: `${user.data().firstName} ${user.data().lastName}`,
				})
			} else {
				reject("error")
			}
		}).catch((e) => {
			reject(e)
		})
	})
}

export const createNewSingleContactList = async details => {
	try{
		if(details.companyId && Object.keys(details.list).length > 0){
			const changedObject = details.list
            changedObject['timestamp'] = moment().unix()
            changedObject['addedBy'] = auth.currentUser.uid
			changedObject['lastUpdated'] = moment().unix()
			changedObject['size'] = 0
			changedObject['addedBy'] = auth.currentUser?.uid

			const add = await database.collection("companies").doc(details.companyId).collection("contactLists").add(changedObject)
			return{payload: add.id, error: null}
		}
	} catch(e) {
		throw new Error(e)
	}
}

export const deleteSingleContactList = async info => {
	try{
		await database.collection("companies").doc(info.companyId).collection("contactLists").doc(info.contactListId).delete()
		return {error: null, payload: null}
	} catch(e) {
		throw new Error(e)
	}
}

export const deleteMultipleContactListsArray = async details => {
	try{
		if(details && details.items.length > 0){
			const deletions = []
			details.items.forEach((key) => {
				const single = deleteContactList({companyId: details.companyId, key: key})
				deletions.push(single)
			})

			return Promise.all(deletions).then((result) => {
				return {error: null}
			})
		} else {
			throw new Error("Kunne ikke slette maler.")
		}
	} catch(e) {
		throw new Error(e)
	}
}


export const deleteContactList = async details => {
	try{
		await database.collection("companies").doc(details.companyId).collection("contactLists").doc(details.key).delete()
		return {error: null}
    } catch(e) {
		throw new Error(e)
    }
}

export const updateSingleContactList = async details => {
	try{
		const changedObject = details.list
		changedObject['lastUpdated'] = moment().unix()
		await database.collection("companies").doc(details.companyId).collection("contactLists").doc(details.listId).update(changedObject)
		return {error: null}
	} catch(e) {
		throw new Error(e)
	}
}